import {
  StoreValidationQueryDocument,
  type StoreValidationQueryQuery,
  type StoreValidationQueryQueryVariables,
} from '~/composables/useStoreValidation.generated'

export const useStoreValidation = async (slug: string) => {
  console.debug('useStoreValidation')
  const {data, error} = await useAsyncQuery<
    StoreValidationQueryQuery,
    StoreValidationQueryQueryVariables
  >(StoreValidationQueryDocument, {slug})

  if (error.value) {
    console.error('store load error', error)
    throw error
  }

  if (!data?.value?.storeBySlug) {
    throw new Error('Store not found.')
  }
  console.debug('store load success')
  return data!.value!.storeBySlug!
}
